import React from "react";

// import { FilterCheckBox, FilterTabs, FilterRadio, FilterDate } from "../Filters";

function tooltip(tooltip) {
  if (tooltip) return <i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip={tooltip}></i>
  else return null
}

export const SearchBoxText = props => <>
  <input type="text"
    placeholder={props.placeholder}
    id={props.id}
    name={props.name}
    value={props.value}
    disabled={props.disabled}
    onChange={props.onChange}
    required={props.required} />
</>
